import request from "@/utils/request";

export function all(id, { page, itemsPerPage }) {
  return request.get(`/card-transactions?loyalty`, {
    params: { page, itemsPerPage },
  });
}
